/**
 * English translations — partial coverage.
 * Missing keys fall back to Russian via t() in src/locales/translate.ts.
 * TODO: Complete en.ts after localization review.
 */
import type { TranslationDictionary } from './types';

export const en: TranslationDictionary = {
  nav: {
    dashboard: 'Dashboard',
    users: 'Users',
    logs: 'Logs',
    staff: 'Staff',
  },
  sidebar: {
    brandSubtitle: 'Admin Panel',
    mainNavigation: 'Main navigation',
  },
  topBar: {
    administration: 'Administration',
    adminFallback: 'Admin',
  },
  auth: {
    accessDenied: {
      title: 'Access denied',
      subtitle: 'You do not have access to this section of Unit 1 Admin Web.',
      backToDashboard: 'Back to Dashboard',
    },
  },
  login: {
    title: 'Unit 1 Admin',
    subtitle: 'Sign in to continue',
    emailLabel: 'Email',
    emailPlaceholder: 'admin@unit1.kz',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    signIn: 'Sign in',
    signingIn: 'Signing in…',
    errorSignIn: 'Invalid email or password.',
    errorTooManyRequests: 'Too many attempts. Please try again later.',
  },
};
